import * as API from "middleware/api";

// eslint-disable-next-line import/prefer-default-export
export const listRequest = (widget, userId) => API.executeWithAccessToken(`/widgets.${widget}`, { userId });
